import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn11() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`XI.`}
            <br />
            {`Final provisions`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`If the relationship established by the Agreement contains an international (foreign) element, then the parties agree that the relationship is governed by Czech law. This does not affect the consumer's rights under generally binding legal regulations.`}</li>
            <li>{`The Provider is not bound by any codes of conduct in relation to the User in the sense of the provisions of Section 1826 par. 1 let. e) of the Civil Code.`}</li>
            <li>{`The out-of-court settlement of consumer disputes from the Agreement is the responsibility of the Czech Trade Inspection, with its registered office at Štěpánská 567/15, 120 00 Praha 2, Company Reg. No.: 000 20 869, Internet address:  http://www.coi.cz`}</li>
            <li>{`The User hereby assumes the risk of a change of circumstances in the sense of Section 1765 para. 2 of the Civil Code.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`If any provision of the Terms and Conditions is or becomes invalid or ineffective, the invalid provision will be replaced by a provision whose meaning is as close as possible to the invalid provision. The invalidity or ineffectiveness of one provision shall not affect the validity of the other provisions. Changes and additions to the purchase Agreement or the terms and conditions require a written form.`}</li>
            <li>{`The Agreement, including the terms and conditions, is archived by the Provider in electronic form and is not accessible.`}</li>
            <li>{`The appendix to the terms and conditions is a sample form for withdrawal from the Agreement.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn11;
